import { NameDto } from '@model/NameDto'

import { SubscriptionRequestType } from './UpdateSubscriptionRequest'

export type SubscriptionRequestBadgeState =
  | 'Pending'
  | 'Processing'
  | 'Deducting Funds'
  | 'In Process'
  | 'Completed'
  | 'Failed'
  | 'In Process Cancel'
  | 'Cancelled'
  | 'Active'
  | 'Active Via Bundle'

export type SubscriptionRequestButtonStateKeys =
  | 'Cancel'
  | 'Unsubscribe'
  | 'Resubscribe'
  | 'Subscribe'

type SubscriptionRequestBadgeStatusTextProps =
  | 'Pending'
  | 'Active'
  | 'Processing'
  | 'Failed'
  | 'Processing'
  | 'Active Via Bundle'
  | 'Pending Cancellation'

type SubscriptionBadgeStatusColor = { type: 'blue' | 'green' | 'danger'; contrast: 'high' | 'low' }
type SubscriptionButtonStatusColor = 'primary' | 'secondary'

export interface ActiveSubscriptionRequest {
  id: string
  state: NameDto
  type: NameDto
  subscriptionDetailId: string
  dueDate: string
  createdDate: string
}

export const SubscriptionRequestBadgeAppearance: Record<
  SubscriptionRequestBadgeState,
  SubscriptionBadgeStatusColor
> = {
  Pending: { type: 'blue', contrast: 'low' },
  Processing: { type: 'blue', contrast: 'low' },
  'Deducting Funds': { type: 'blue', contrast: 'low' },
  'In Process': { type: 'blue', contrast: 'low' },
  Completed: { type: 'green', contrast: 'low' },
  Failed: { type: 'danger', contrast: 'low' },
  'In Process Cancel': { type: 'blue', contrast: 'low' },
  Cancelled: { type: 'blue', contrast: 'low' },
  Active: { type: 'green', contrast: 'low' },
  'Active Via Bundle': { type: 'blue', contrast: 'low' },
}

export const SubscriptionRequestBadgeStatusText: Record<
  SubscriptionRequestBadgeState,
  SubscriptionRequestBadgeStatusTextProps
> = {
  Pending: 'Pending',
  Processing: 'Pending',
  'Deducting Funds': 'Processing',
  'In Process': 'Processing',
  Completed: 'Active',
  Failed: 'Failed',
  'In Process Cancel': 'Processing',
  Cancelled: 'Pending Cancellation',
  Active: 'Active',
  'Active Via Bundle': 'Active Via Bundle',
}

export const SubscriptionRequestButtonAppearance: Record<string, SubscriptionButtonStatusColor> = {
  Subscribe: 'primary',
  Unsubscribe: 'secondary',
  Resubscribe: 'secondary',
  Cancel: 'secondary',
}

export const SubscriptionRequestButtonStatusKeys: Record<
  string,
  SubscriptionRequestButtonStateKeys
> = {
  Unsubscribe: 'Unsubscribe',
  Resubscribe: 'Resubscribe',
  Cancel: 'Cancel',
  Subscribe: 'Subscribe',
}

export interface InfoModalProps {
  title?: string
  body?: string
}

export type SubscriptionRequestBadgeStatusProps = keyof typeof SubscriptionRequestBadgeStatusText &
  keyof typeof SubscriptionRequestButtonStatusKeys

export type SubscriptionRequest = {
  id: string
  state: {
    id: number
    name: SubscriptionRequestBadgeState
  }
  subscriptionDetailId: string
  dueDate: string
  type: NameDto<SubscriptionRequestType>
  subscriptionTimeInForce?: NameDto
  activeSubscriptionRequest?: ActiveSubscriptionRequest
}

export type SubscriptionDetailType = {
  name: string
  description: string
  id?: string
  activeViaBundleSubscriptionRequest?: SubscriptionRequest
  amount?: number
  activeSubscriptionRequest?: ActiveSubscriptionRequest
  subscriptionRequest?: SubscriptionRequest
}

export interface TradingPlatformSubscriptionItem {
  id: string | number
  subName?: string
  name?: string
  description?: string
  url?: string
  isActiveViaPackage?: boolean
  subscriptionRequest?: SubscriptionRequest
  activeSubscriptionRequest?: ActiveSubscriptionRequest
  subscriptionTimeInForce?: { id: number; name: string }
  details?: SubscriptionDetailType[]
}

export interface SubscriptionsTradingPlatformsTableProps {
  items: TradingPlatformSubscriptionItem[]
}

export interface TradingPlatformsItemProps extends TradingPlatformSubscriptionItem {
  minAmount?: number
  maxAmount?: number
  imageUrlMobile?: string
  imageUrl?: string
  price?: number
  isOpen?: boolean
  type: string
  subscriptions?: TradingPlatformSubscriptionItem[]
  subscriptionRequest?: SubscriptionRequest
}

export interface TradingPlatformsPackagesProps extends TradingPlatformSubscriptionItem {
  productType?: string
  price?: number
}

export interface TradingPlaformsDataProps {
  id: string
  subName?: string
  name?: string
  type: string
  description?: string
  url?: string
  imageUrl?: string
  imageUrlMobile?: string
  minAmount?: number
  maxAmount?: number
  subscriptions: TradingPlatformSubscriptionItem[]
}
